module.exports = __webpack_public_path__ + "static/media/icon-error.a1043ed5.svg";